import { useState } from "react";
import { useHistory, Link } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "react-loader-spinner";
import httpClient from "../../custom-hooks/httpClient";
import { useDispatch } from "react-redux";
import { resetUser } from "../../app-store/userSlice";
import LoginImageBanner from "../LoginImgBanner";
import logo from "../../images/kegow-color.png";

function Login() {
  const history = useHistory();
  const dispatch = useDispatch();

  const [credentials, setCredentials] = useState({
    phoneNumber: "",
    securityPin: "",
  });
  const [isLoggingIn, setisLoggingIn] = useState(false);

  const handleChange = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setisLoggingIn(true);
    localStorage.clear();
    dispatch(resetUser());
    httpClient
      .post(`/login`, {
        phone_number: `234${credentials.phoneNumber.substring(1)}`,
        security_pin: credentials.securityPin,
        mac_address: "web",
      })
      .then(({ status, data }) => {
        setisLoggingIn(false);
        if (status === 200) {
          const { token, user } = data;
          localStorage.setItem("tk", token);
          localStorage.setItem("id", user.id);
          if (!user.is_verified && !user.mifos_client_id) {
            history.push("/verify");
          } else {
            history.push("/dashboard");
          }
        }
      })
      .catch((err) => {
        setisLoggingIn(false);
        // console.log(err.response.data);
        toast.error(
          err && err.response ? err.response.data.message : "Error logging in"
        );
      });
  };

  return (
    <>
      <section className="login-page row min-vh-100 d-flex mt-6 mt-md-0 flex-row">
        <LoginImageBanner />

        <div className="d-flex col-12 align-items-center col-md-6">
          <div className="p-8 container me-md-4">
            <img
              className="keg-login-logo mb-6 mb-md-5"
              src={logo}
              alt="kegow-pic"
            />

            <h1 className="mb-0 fw-medium text-primary">Sign In</h1>
            <p className="mb-6 ">Start with your Phone Number.</p>
            <form className="mb-6" onSubmit={handleSubmit}>
              <label className="form-label" htmlFor="number">
                Phone Number
              </label>
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <span className="input-group-text">+234</span>
                </div>
                <input
                  type="tel"
                  className="form-control"
                  onChange={handleChange}
                  name="phoneNumber"
                  title="Numbers only, e.g. 08023456789"
                  maxLength="11"
                  required
                  // value={phoneNumber}
                  pattern="0[0-9]{10}"
                  id="number"
                  placeholder="08023456789"
                />
              </div>
              <div className="form-group mb-5">
                <label className="form-label" htmlFor="pin">
                  Security PIN
                </label>
                <input
                  type="password"
                  className="form-control"
                  onChange={handleChange}
                  name="securityPin"
                  title="Numbers only, e.g. 1234"
                  maxLength="4"
                  id="pin"
                  required
                  pattern="[0-9]{4}"
                  placeholder="e.g. 1234"
                />
              </div>
              {isLoggingIn ? (
                <button className="btn w-100 btn-primary">
                  <Loader type="Oval" color="#fff" width={20} height={20} />
                </button>
              ) : (
                <button className="btn w-100 btn-primary" type="submit">
                  Next
                </button>
              )}
            </form>
            <p className="mb-3">
              <Link to="/forgot-pin" className="text-decoration-none fw-bold">
                Forgot Security PIN?
              </Link>
            </p>
            <p className="mb-3">
              Don't have an account yet?{" "}
              <a href="/signup" className="text-decoration-none fw-bold">
                Sign up
              </a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Login;
